import React from 'react';
import Homepage from 'modules/lobby/containers/Homepage';
import InitContainer from 'modules/auth/containers/InitContainer';
import AppWrapper from 'modules/common/AppWrapper';
import Login from 'modules/auth/containers/Login';
import Logout from 'modules/auth/containers/Logout';
import SetSession from 'modules/auth/containers/SetSession';
import BuyGems from 'modules/lobby/containers/BuyGems';
import Privacy from 'modules/auth/containers/Privacy';
import { FavoriteWrapper } from 'modules/lobby/components/Favorite';
import ComingSoon from 'modules/lobby/components/ComingSoon';
import Terms from 'modules/auth/containers/Terms';

function App() {
  if (window.location.pathname === '/session') {
    return (
      <AppWrapper>
        <SetSession />
      </AppWrapper>
    );
  }
  if (window.location.pathname === '/authenticate') {
    return (
      <AppWrapper>
        <Login />
      </AppWrapper>
    );
  }
  if (window.location.pathname === '/buy-gems') {
    return (
      <AppWrapper>
        <InitContainer>
          <BuyGems />
        </InitContainer>
      </AppWrapper>
    );
  }
  if (window.location.pathname === '/logout') {
    return (
      <AppWrapper>
        <InitContainer>
          <Logout />
        </InitContainer>
      </AppWrapper>
    );
  }
  if (window.location.pathname === '/privacy') {
    return (
      <div className="p-12">
        <Privacy />
      </div>
    );
  }
  if (window.location.pathname === '/terms') {
    return (
      <div className="p-12">
        <Terms />
      </div>
    );
  }
  if (window.location.pathname === '/coming-soon') {
    return <ComingSoon />;
  }
  return (
    <AppWrapper>
      <InitContainer>
        <FavoriteWrapper>
          <Homepage />
        </FavoriteWrapper>
      </InitContainer>
    </AppWrapper>
  );
}

export default App;
